<ul class="second-level" role="menu" aria-label="">
  <!-- Virtual items for measurement -->
  @for (item of menuItems; track item) {
    <li class="virtual">
      <a class="nav-item tw:whitespace-nowrap">
        <ng-container [ngTemplateOutlet]="item.content" />
      </a>
    </li>
  }

  <!-- Visible items -->
  @for (item of menuItems; track item; let i = $index) {
    @if (!item.isHidden && !hiddenMenuItems[i]) {
      <li
        [class.active]="item.isActive$ | async"
        [class.is-open]="item.isActive$ | async"
        [class.tw:inline-flex]="item.isDisabled"
        [class.tw:items-center]="item.isDisabled"
      >
        <a
          class="nav-item tw:items-center tw:flex tw:whitespace-nowrap"
          role="menuitem"
          [attr.aria-current]="item.isActive$ | async"
          [attr.href]="item.href"
          [ngClass]="{ 'disabled-state tw:pr-2': item.isDisabled }"
          (click)="item.click.emit($event)"
        >
          <ng-container [ngTemplateOutlet]="item.content" />
          @if (item.isExternalLink()) {
            <ga-icon [icon]="icons.ExternalLink" />
          }
        </a>
        @if (item.isDisabled) {
          <ga-icon [gaTooltip]="item.tooltipText" [icon]="icons.Info" />
        }
      </li>
    }
  }

  <!-- "More" dropdown for hidden items -->
  @if (anyHiddenMenuItem) {
    <li
      class="menudrop dropdown tw:flex-shrink-0"
      role="none"
      diVudDropdown
      #moreDropdown="diVudDropdown"
      [class.open]="moreDropdown.isOpen$ | async"
    >
      <a
        class="dropdown-toggle nav-item tw:flex tw:items-center tw:px-2 tw:cursor-pointer"
        id="vud-navbar-secondary-more-menu"
        role="menuitem"
        diVudDropdownToggle
        [attr.aria-haspopup]="true"
        [attr.aria-label]="moreLabel"
      >
        <ga-icon [icon]="icons.EllipsisVertical" />
      </a>
      <ul class="dropdown-menu tw:min-w-60" aria-labelledby="vud-navbar-secondary-more-menu" diVudDropdownMenu>
        @for (item of menuItems; track item; let i = $index) {
          @if (!item.isHidden && hiddenMenuItems[i]) {
            <li role="none" [class.active]="item.isActive$ | async">
              <a
                class="tw:flex tw:items-center"
                role="menuitem"
                [attr.aria-current]="item.isActive$ | async"
                [attr.href]="item.href"
                [ngClass]="{ 'disabled-state': item.isDisabled }"
                (click)="item.click.emit($event)"
              >
                <ng-container [ngTemplateOutlet]="item.content" />
                @if (item.isExternalLink()) {
                  <ga-icon class="tw:ml-2" [icon]="icons.ExternalLink" />
                }
              </a>
            </li>
          }
        }
      </ul>
    </li>
  }
</ul>
